<ng-container *ngFor="let placement of placements">
	<ng-template [ngIf]="alerts[placement].length > 0">
		<icp-alert-item
			[placement]="placement"
			[alerts]="alerts[placement]"
			(close)="onClose($event)">
		</icp-alert-item>
	</ng-template>
</ng-container>